import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  isDueDatePassed: false,
  InvoicepPaymentDeatailsList: [],
  InvoicepPaymentDeatailsDataList: [],
  InvoicepPaymentDeatailsCheckList: [],
};

export default function InvoiceReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_INVOICEPAYMENTDATA_INIT_ACTION:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_INVOICEPAYMENTDATA_SUCCESS_ACTION:
      const currentDate = new Date();
      const dueDate = new Date(
        action?.payload?.response_data[0]?.invoiceDueDate
      );
      const isDueDatePassed = currentDate > dueDate;
      return {
        ...state,
        InvoicepPaymentDeatailsList: action.payload.response_data.resp,
        loading: false,
        isDueDatePassed,
      };
    case actionTypes.FETCH_INVOICEPAYMENTDATA_FAIL_ACTION:
      return {
        ...state,
        loading: false,
        InvoicepPaymentDeatailsList: [],
      };

    case actionTypes.FETCH_INVOICEPAYMENTDETAILS_INIT_ACTION:
      return {
        ...state,
        InvoicepPaymentDeatailsDataList: [],
      };
    case actionTypes.FETCH_INVOICEPAYMENTDETAILS_SUCCESS_ACTION:
      const pdfUrl = action.payload.response_data?.resp;
      // pdfUrl && window.open(pdfUrl, "_blank");
      return {
        ...state,
        InvoicepPaymentDeatailsDataList: pdfUrl,
      };
    case actionTypes.FETCH_INVOICEPAYMENTDETAILS_FAIL_ACTION:
      return {
        ...state,
        InvoicepPaymentDeatailsDataList: [],
      };

    case actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_INIT_ACTION:
      return {
        ...state,
        InvoicepPaymentDeatailsCheckList: [],
      };
    case actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        InvoicepPaymentDeatailsCheckList: action.payload.response_data,
      };
    case actionTypes.FETCH_INVOICEPAYMENTCHECKDETAILS_FAIL_ACTION:
      return {
        ...state,
        InvoicepPaymentDeatailsCheckList: [],
      };

    default:
      return {
        ...state,
      };
  }
}
